// extracted by mini-css-extract-plugin
export var compactFilters = "_gt-4";
export var detailImage = "_gt-1";
export var dropdownContainer = "_gt-2";
export var imageContainer = "_gt-0";
export var selectedCard = "_gt-3";